import React, { useState } from 'react';

import DropDownSelect, { DropDownColorTheme } from '../../dropDownSelect';
import { MarketSearchOptions } from '../tabs/marketDashboard';

const SEARCH_SELECT_WIDTH = '175px';

const validDateWindows = [
    'Last month',
    'Last 3 months',
    'Last 6 months',
    'Last 12 months',
];

export const numberWeeks = {
    'Last month': 4,
    'Last 3 months': 13,
    'Last 6 months': 26,
    'Last 12 months': 52,
};

const RealEstateMarketDateFilters = ({ filters, onChange }) => {
    const [searchDates, setSearchDates] = useState(
        filters[MarketSearchOptions.DateWindow],
    );

    const handleSelectDateWindow = (selected) => {
        setSearchDates(selected);
        onChange({ [MarketSearchOptions.DateWindow]: selected });
    };

    return (
        <div className="d-flex flex-column flex-lg-row gap-3 justify-content-xs-start align-items-lg-center">
            <div style={{ width: SEARCH_SELECT_WIDTH }}>
                <DropDownSelect
                    options={validDateWindows}
                    selected={searchDates}
                    onSelect={handleSelectDateWindow}
                    colorTheme={DropDownColorTheme.dark}
                    sortOptions={false}
                />
            </div>
        </div>
    );
};

export default RealEstateMarketDateFilters;
